import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";

const VerificationPhoneModal = ({ isOpen, ...props }) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(isOpen); // hiển thị khi mount, hoặc đổi theo state thật

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const handleOk = () => {
    setOpen(false);
    navigate("/ca-nhan/xac-thuc-sdt"); // chuyển trang nội bộ, không reload
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      title="Yêu cầu xác nhận số điện thoại"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Đồng ý xác nhận"
      cancelText="Để sau"
      centered
    >
      <p>Tài khoản chưa xác nhận số điện thoại.</p>
      <p>
        Vui lòng xác nhận số điện thoại để đảm bảo an toàn và nhận thông báo.
      </p>
    </Modal>
  );
};

export default VerificationPhoneModal;
